const C = require("../constants");
const initial_data = {open: false, provider:{id:null, full_name:'', email:'', factory:'', phone:''}};

function ProviderDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.PROVIDER_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ProviderDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ProviderDialogReducer.js